export const TableTitles = {
    registrant_id: "ID",
    registrant_name: "ယောဂီအမည်",
    registrant_phone: "ဖုန်းနံပါတ်",
    registrant_nrc: "နိုင်ငံသားမှတ်ပုံတင်အမှတ်",
    registrant_address: "နေရပ်လိပ်စာ",
    registrant_book_id: "စာအုပ်အမှတ်",
    registrant_dob: "မွေးနေ့",
    total_registrants: "ယောဂီအရေအတွက်",
    registrant_gender: "ကျား/မ",
    registrant_half_body_photo: "ကိုယ်တစ်ပိုင်းပုံ",
    registrant_father_name: "ဖခင်အမည်",
    registrant_medical_history: "ဖြစ်ဖူးသောရောဂါ",
    registrant_current_health_condition: "လက်ရှိကျန်းမာရေးအခြေအနေ",
    registrant_status: "Status",

    retreat_name: "တရားစခန်းအမည်",
    retreat_level: "တရားစခန်းအဆင့်",
    retreat_start_date: "စတင်ကျင်းပမည့်ရက်",
    retreat_end_date: "ပြီးဆုံးမည့်ရက်",
    retreat_duration: "ကျင်းပမည့်ရက်ကြာချိန်",
    retreat_start_month: "ကျင်းပမည့်လ",
    retreat_status: "Status",
    previous_attended_retreats: "ဝင်ရောက်ဖူးသော တရားစခန်း",
    retreat_attendance: "Check In / Out",
    retreat_rooms: 'အခန်းများ',

    donation_date: "လှူဒါန်းသည့်ရက်",
    donation_amount: "လှူဒါန်းငွေ",
    donation_type: "အမျိုးအစား",
    donor_name: "လှူဒါန်းသူအမည်",
    donor_phone: "လှူဒါန်းသူဖုန်းနံပါတ်",
    donor_address: "လှူဒါန်းသူလိပ်စာ",
    donation_payment_method: "လှူဒါန်းငွေ ပေးချေမှုနည်းလမ်း",
    retreat_to_which_donated: "လှူဒါန်းသည့် တရားစခန်း",

    action: "Actions",
    city: "မြို့",
    state: "ပြည်နယ်/တိုင်း",
    No: "No.",
    status: "Status",
}